import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=6ac46eee&scoped=true"
import script from "./ButtonDefault.vue?vue&type=script&lang=ts"
export * from "./ButtonDefault.vue?vue&type=script&lang=ts"
import style0 from "./ButtonDefault.vue?vue&type=style&index=0&id=6ac46eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac46eee",
  null
  
)

export default component.exports